import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function About() {
  return (
    <>
      <Helmet>
        <title>About Us - Aramco Leads Pro</title>
        <meta name="description" content="Learn about Aramco Leads Pro CRM platform and our mission to help businesses manage leads and customer relationships effectively." />
      </Helmet>

      <div style={{ background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)', color: 'white', padding: '4rem 2rem', textAlign: 'center' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h1 style={{ fontSize: '3rem', fontWeight: '800', marginBottom: '1rem' }}>About Aramco Leads Pro</h1>
          <p style={{ fontSize: '1.25rem', opacity: 0.95 }}>CRM & Lead Management Platform</p>
        </div>
      </div>

      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '4rem 2rem' }}>
        
        {/* CRITICAL DISCLAIMER */}
        <div style={{ background: '#fef2f2', border: '2px solid #ef4444', borderRadius: '12px', padding: '2rem', marginBottom: '3rem' }}>
          <h2 style={{ fontSize: '1.5rem', fontWeight: '700', color: '#991b1b', marginBottom: '1rem' }}>
            ⚠️ Important: We Are NOT a Direct Lender
          </h2>
          <p style={{ color: '#7f1d1d', lineHeight: '1.6', marginBottom: '0.5rem' }}>
            <strong>Aramco Leads Pro is a lead generation and CRM platform.</strong> We connect consumers 
            with licensed lending partners but do not make loans, extend credit, or make lending decisions.
          </p>
          <p style={{ color: '#7f1d1d', lineHeight: '1.6' }}>
            All lending activities are performed by independent, licensed financial institutions. We do not 
            access credit reports, set loan terms, or participate in underwriting.
          </p>
        </div>

        <div style={{ marginBottom: '4rem', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.1)' }}>
          <img 
            src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1200&h=500&fit=crop" 
            alt="Professional team" 
            style={{ width: '100%', height: '500px', objectFit: 'cover' }}
          />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '3rem', marginBottom: '4rem' }}>
          <div>
            <h2 style={{ fontSize: '2rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem' }}>Our Mission</h2>
            <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#4b5563', marginBottom: '1rem' }}>
              At Aramco Leads Pro, we empower businesses to manage their leads and customer relationships more effectively. 
              Our CRM platform provides the tools needed to track leads, automate follow-ups, and maintain strong customer relationships.
            </p>
            <p style={{ fontSize: '1rem', lineHeight: '1.8', color: '#6b7280', fontStyle: 'italic' }}>
              <strong>Business Model:</strong> We operate as a lead generation and CRM platform, connecting consumers 
              with licensed service providers including financial institutions. We do not provide lending services directly.
            </p>
          </div>

          <div>
            <h2 style={{ fontSize: '2rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem' }}>Our Values</h2>
            <ul style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#4b5563', listStyle: 'none', padding: 0 }}>
              <li style={{ marginBottom: '0.5rem' }}>✓ Compliance First</li>
              <li style={{ marginBottom: '0.5rem' }}>✓ Customer Privacy</li>
              <li style={{ marginBottom: '0.5rem' }}>✓ Transparent Service</li>
              <li style={{ marginBottom: '0.5rem' }}>✓ Quality Support</li>
              <li style={{ marginBottom: '0.5rem' }}>✓ Innovation</li>
            </ul>
          </div>
        </div>

        <div style={{ background: '#f9fafb', padding: '3rem', borderRadius: '12px', marginBottom: '4rem' }}>
          <h2 style={{ fontSize: '2rem', fontWeight: '700', color: '#1f2937', marginBottom: '2rem', textAlign: 'center' }}>
            Why Choose Aramco Leads Pro?
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '2rem' }}>
            {[
              { title: 'A2P 10DLC Compliant', desc: 'Fully registered and compliant with carrier requirements' },
              { title: 'High Deliverability', desc: '99%+ message delivery rates with premium routing' },
              { title: 'Expert Support', desc: 'Dedicated team to help you succeed' },
              { title: 'Transparent Reporting', desc: 'Real-time analytics and detailed reports' }
            ].map((item, idx) => (
              <div key={idx} style={{ textAlign: 'center' }}>
                <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#1e40af', marginBottom: '0.5rem' }}>
                  {item.title}
                </h3>
                <p style={{ color: '#6b7280', lineHeight: '1.6' }}>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div style={{ background: '#f9fafb', padding: '2rem', borderRadius: '12px', border: '1px solid #e5e7eb' }}>
          <h3 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem' }}>Company Information</h3>
          <p><strong>Legal Name:</strong> Aramco 1 USA Corporation</p>
          <p><strong>DBA:</strong> Aramco Leads Pro</p>
          <p><strong>EIN:</strong> 33-1773365</p>
          <p><strong>Address:</strong> 11 Linden Ave, Kearny, NJ 07032, United States</p>
        </div>
      </div>
    </>
  );
}
